import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App';
import { HomePage } from './pages/Home' // Ou seu sistema de rotas
import './index.css' // Onde está o @tailwind

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)